// Send back (spec C6; the Renewals board's dialog, Dialog and ConfirmPopup cards): the AE says why,
// required, then confirms. The renewal stays with, or goes back to, whoever the work came from, and
// the note shows at the top of their Record. Opened by use-handoff-answers.tsx.
import { useState } from 'react';
import { ConfirmPopup } from '../shell/ConfirmPopup';
import { Dialog } from '../shell/Dialog';
import { sendBackConfirm, sendBackHelp, type AnswerRow } from './ae-handoff-lines';
import { noteMax } from './notes-lines';

/**
 * Send back (the Renewals board's dialog; spec C6): why, required, then the confirm. The note shows
 * at the top of the VA's Record.
 */
export function SendBackDialog({
  row,
  busy,
  onClose,
  onSend,
}: {
  row: AnswerRow;
  busy: boolean;
  onClose: () => void;
  /** True once sent; the reason it was not, otherwise. */
  onSend: (note: string) => Promise<string | boolean>;
}) {
  const [note, setNote] = useState('');
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const text = note.trim();
  const subline = [
    row.insured,
    row.carrier ?? 'Carrier not in AMS360',
    row.line,
    row.policyNumber,
  ].join(' | ');
  const send = async () => {
    const result = await onSend(text);
    if (result !== true) {
      setConfirming(false);
      setError(typeof result === 'string' ? result : null);
    }
  };
  return (
    <>
      <Dialog
        id="sb-t"
        title="Send back"
        subline={subline}
        onClose={onClose}
        footer={
          <>
            <button type="button" className="btn" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary ml-auto"
              disabled={!text || busy}
              onClick={() => setConfirming(true)}
            >
              Send back
            </button>
          </>
        }
      >
        <div>
          <label className="flab" htmlFor="sb-note">
            Why are you sending it back? <span className="req">*</span>
          </label>
          <textarea
            id="sb-note"
            className="input"
            placeholder="For example: increase is under our threshold, go ahead and renew"
            maxLength={noteMax}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <p className="fnote">{sendBackHelp(row.handoff)}</p>
        </div>
        {error && (
          <p className="ferr" role="alert">
            {error}
          </p>
        )}
      </Dialog>
      {confirming && (
        <ConfirmPopup
          {...sendBackConfirm(row.insured, row.handoff)}
          action={busy ? 'Sending back' : 'Send back'}
          busy={busy}
          onConfirm={() => void send()}
          onCancel={() => setConfirming(false)}
        />
      )}
    </>
  );
}
